import { useState } from 'react';
import { Box, Tab } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { InviteUsersTab } from '../InviteUsersTab/InviteUsersTab';
import { CreateParticipantsLightTab } from '../CreateParticipantsLightTab/CreateParticipantsLightTab';
import { DialogTabs, InviteButton, StyledDialog } from './InviteUserDialog.styles';

enum AddUsersTab {
  InviteUsers = 0,
  CreateManagedUsers = 1
}

export const InviteUserDialog = () => {
  const [open, setOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState<AddUsersTab>(AddUsersTab.InviteUsers);
  const { t } = useTranslation();

  const handleOpen = () => {
    setSelectedTab(AddUsersTab.InviteUsers);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box>
      <InviteButton variant="outlined" color='secondary' onClick={handleOpen} data-testid="invite-user-button-navbar">
        {t('inviteUser.inviteUserButtonNavbar')}
      </InviteButton>
      <StyledDialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTabs
          value={selectedTab}
          onChange={(_, value) => setSelectedTab(value as AddUsersTab)}
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
          aria-label="Add users tabs"
        >
          <Tab label={t('addUsersDialog.inviteUsersTab')} data-testid="invite-users-tab" />
          <Tab label={t('addUsersDialog.createManagedUsersTab')} data-testid="create-managed-users-tab" />
        </DialogTabs>
        {selectedTab === AddUsersTab.InviteUsers
          ? <InviteUsersTab onClose={handleClose} />
          : <CreateParticipantsLightTab onClose={handleClose} />}
      </StyledDialog>
    </Box>
  );
};
